/* Zellaforte PDP diagnostics (zf_pdp_* / zf_section_* / zf_buybox_* events).

   Answers "why did they NOT add to cart" — the funnel events in zf-analytics.js
   only record what people DID. This records how far they got and where they
   stopped:

     zf_pdp_scroll        depth milestones (25/50/75/90 %) + time to reach
     zf_section_viewed    per Shopify section, once, ≥50 % visible for ≥1 s
     zf_buybox_viewed     the offer actually entered the viewport
     zf_buybox_interacted plan toggle / qty touched (intent without ATC)
     zf_faq_opened        which question — objection mining
     zf_pdp_exit          one summary row per visit (max scroll, dwell,
                          sections seen, buybox seen/touched, did_atc)

   Fans out through window.zfTrack (dataLayer + PostHog, consent handled there).
   Never fires Meta — these are diagnostics, not conversion signals.

   Sections are discovered generically via [id^="shopify-section-"], so adding
   or reordering sections in the theme editor needs no change here. Every
   selector lookup degrades gracefully: a missing element just skips its probe. */
(function () {
  'use strict';

  if (!window.zfTrack) return;

  var root = document.querySelector('.product') || document.querySelector('main');
  if (!root) return;

  /* Bis 2026-08-09 nur Produktseiten. Auf der Ads-Landingpage feuerte deshalb
     KEIN einziges dieser Events — in PostHog über 60 Tage null zf_section_viewed
     und null zf_buybox_viewed, obwohl das Skript dort längst geladen wurde
     (snippets/zf-analytics.liquid wird auch aus layout/kerabiotic-lp.liquid
     gerendert). Damit liess sich genau die Frage nicht beantworten, für die es
     gebaut wurde: wie weit kommen Besucher, bevor sie abspringen.
     Die LP erkennt man am Wurzel-Element der kbb-Sections. */
  var isPdp = /\/products\//.test(window.location.pathname);
  var isLp = !!document.querySelector('[data-kbb-root]');
  if (!isPdp && !isLp) return;
  var pageType = isPdp ? 'pdp' : 'lp';

  var t0 = Date.now();
  var sent = false;

  var stateData = {
    maxScrollPct: 0,
    sectionsSeen: [],
    lastSection: '',
    buyboxSeen: false,
    buyboxInteracted: false,
    buyboxInteractions: [],
    faqOpened: [],
    didAtc: false,
    mediaInteracted: false
  };

  function secondsSinceLoad() {
    return Math.round((Date.now() - t0) / 1000);
  }

  function scrollPct() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return 100;
    return Math.min(100, Math.round(((window.scrollY || doc.scrollTop) / scrollable) * 100));
  }

  /* ---------- scroll milestones ---------- */

  var MILESTONES = [25, 50, 75, 90];
  var hitMilestones = {};
  var lastScrollCheck = 0;

  /* Time-throttled rather than rAF-throttled on purpose: rAF is suspended in
     background/occluded tabs, which would silently drop milestones. 150 ms is
     far below human scroll-reading speed. */
  function onScroll() {
    var now = Date.now();
    if (now - lastScrollCheck < 150) return;
    lastScrollCheck = now;

    var pct = scrollPct();
    if (pct > stateData.maxScrollPct) stateData.maxScrollPct = pct;
    for (var i = 0; i < MILESTONES.length; i++) {
      var m = MILESTONES[i];
      if (pct >= m && !hitMilestones[m]) {
        hitMilestones[m] = true;
        window.zfTrack('zf_pdp_scroll', {
          page_type: pageType,
          depth_pct: m,
          seconds_to_reach: secondsSinceLoad()
        });
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- section visibility ---------- */

  function sectionLabel(el) {
    // "shopify-section-template--123__benefits_capsule_scroll_p2" → "benefits_capsule_scroll_p2"
    var id = el.id.replace(/^shopify-section-/, '');
    var parts = id.split('__');
    return parts.length > 1 ? parts[parts.length - 1] : id;
  }

  if ('IntersectionObserver' in window) {
    var sections = document.querySelectorAll('[id^="shopify-section-"]');
    var dwellTimers = {};

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        var label = sectionLabel(el);

        if (entry.isIntersecting) {
          // require ≥1 s of continuous visibility so fast scroll-throughs don't count
          if (dwellTimers[label]) return;
          dwellTimers[label] = window.setTimeout(function () {
            dwellTimers[label] = null;
            if (stateData.sectionsSeen.indexOf(label) !== -1) return;
            stateData.sectionsSeen.push(label);
            stateData.lastSection = label;
            window.zfTrack('zf_section_viewed', {
              page_type: pageType,
              section_name: label,
              order_index: Array.prototype.indexOf.call(sections, el),
              seconds_since_load: secondsSinceLoad(),
              scroll_pct: scrollPct()
            });
          }, 1000);
        } else if (dwellTimers[label]) {
          window.clearTimeout(dwellTimers[label]);
          dwellTimers[label] = null;
        }
      });
      /* threshold war 0.5 — unerreichbar fuer jede Sektion ueber der
         doppelten Bildschirmhoehe, weil nie mehr als eine Bildschirmfuellung
         gleichzeitig sichtbar sein kann. formula/voices/offer/close sind
         genau die vier groessten Sektionen der Seite (1812-2876px) und
         fielen deshalb komplett aus der Messung. Der 1-Sekunden-Dwell-Timer
         oben ist bereits das eigentliche Kriterium "wirklich gesehen" —
         threshold 0 startet ihn beim ersten sichtbaren Pixel, unabhaengig
         von der Sektionshoehe. */
    }, { threshold: 0 });

    Array.prototype.forEach.call(sections, function (el) {
      sectionObserver.observe(el);
    });

    /* ---------- buy box seen ---------- */

    var buybox = document.querySelector('.kbx') ||
                 document.querySelector('#kbb-buybox') ||
                 document.querySelector('.product-form__buttons') ||
                 document.querySelector('[data-zf-buybox]');

    if (buybox) {
      var buyboxObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || stateData.buyboxSeen) return;
          stateData.buyboxSeen = true;
          buyboxObserver.disconnect();
          window.zfTrack('zf_buybox_viewed', {
            page_type: pageType,
            seconds_since_load: secondsSinceLoad(),
            scroll_pct: scrollPct()
          });
        });
      }, { threshold: 0.5 });
      buyboxObserver.observe(buybox);
    }
  }

  /* ---------- buy-box interaction (intent without purchase) ---------- */

  function recordBuyboxInteraction(kind, detail) {
    if (stateData.buyboxInteractions.indexOf(kind) !== -1) return; // once per kind
    stateData.buyboxInteractions.push(kind);
    stateData.buyboxInteracted = true;
    window.zfTrack('zf_buybox_interacted', {
      page_type: pageType,
      interaction_type: kind,
      interaction_detail: detail || '',
      seconds_since_load: secondsSinceLoad()
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el || !el.closest) return;

    if (el.closest('.kbx-tab')) {
      var tab = el.closest('.kbx-tab');
      var title = tab.querySelector('.kbx-tab__title');
      recordBuyboxInteraction('plan_toggle', title ? title.textContent.trim().slice(0, 40) : '');
      return;
    }
    if (el.closest('.kbx-qty__btn')) {
      recordBuyboxInteraction('quantity', '');
      return;
    }
    /* LP-Äquivalente: Plan-Karten in der Buy Box und die Segment-Knöpfe in der
       Sticky-Leiste (sections/zellaforte-kb-hair-b-hero.liquid). */
    /* `.kbb-plan` ist das <label>, das die ganze Plan-Karte umschliesst — ein
       Klick irgendwo darauf wählt den Plan. NICHT `[data-kbb-plan]` verwenden:
       das Attribut heisst `data-kbb-plan-input` und sass am <input>, der
       Selektor traf also nie. Dadurch war `buybox_interacted` auf der LP
       strukturell IMMER false — die daraus gelesene Aussage „0 von 40 haben den
       Umschalter berührt" war ein Messartefakt, kein Nutzerverhalten.
       Korrigiert 2026-08-10. */
    var kbbPlan = el.closest('.kbb-plan') || el.closest('[data-kbb-seg]');
    if (kbbPlan) {
      /* Nur den Plannamen, nicht den gesamten Kartentext — sonst steht in
         PostHog „90-Tage-RoutineBeste Wahl€1,54 €139,00 g…" statt „90-Tage-Routine". */
      var titelEl = kbbPlan.querySelector ? kbbPlan.querySelector('.kbb-plan__title') : null;
      var label = kbbPlan.getAttribute('data-kbb-seg') ||
                  (titelEl ? titelEl.textContent : kbbPlan.textContent || '')
                    .replace(/\s+/g, ' ').trim().slice(0, 40);
      recordBuyboxInteraction('plan_toggle', label);
      return;
    }
    // FAQ — objection mining
    /* Die LP nutzt ein eigenes Akkordeon (data-kbb-accordion-btn) statt
       .faq-toggle — beide hier abfangen, sonst fehlt das Einwand-Mining. */
    var kbbAcc = el.closest('[data-kbb-accordion-btn]');
    if (kbbAcc) {
      var kbbQ = (kbbAcc.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120);
      if (kbbQ && stateData.faqOpened.indexOf(kbbQ) === -1) {
        stateData.faqOpened.push(kbbQ);
        /* zone: Auf der Haar-LP tragen DREI Akkordeons dasselbe
           data-kbb-accordion-btn — Buy-Box-Details, "Drei Fragen" und die FAQ am
           Seitenende. Bisher liessen sie sich nur ueber den Fragetext
           auseinanderhalten, die Aussage "Zutaten ist das meistgeklickte
           Element" war also erschlossen statt abfragbar. Rein additiv, damit
           die bisherige Zeitreihe vergleichbar bleibt. */
        var accRoot = kbbAcc.closest('[data-kbb-accordion]');
        window.zfTrack('zf_faq_opened', {
          page_type: pageType,
          question: kbbQ,
          zone: accRoot ? accRoot.getAttribute('data-kbb-accordion-zone') || '' : '',
          seconds_since_load: secondsSinceLoad()
        });
      }
      return;
    }
    var toggle = el.closest('.faq-toggle');
    if (toggle) {
      // The question is the toggle's own first <p> (faq-section.liquid), not an
      // .h3 — the icon wrapper is the only other child.
      var qEl = toggle.querySelector('p');
      var question = qEl ? qEl.textContent.trim().slice(0, 120) : '';
      // .faq-toggle also collapses — only record the first open per question
      if (question && stateData.faqOpened.indexOf(question) === -1) {
        stateData.faqOpened.push(question);
        window.zfTrack('zf_faq_opened', {
          page_type: pageType,
          question: question,
          seconds_since_load: secondsSinceLoad()
        });
      }
      return;
    }
    /* Produktgalerie.
       .kbb-gallery__thumb ergaenzt 2026-08-24: Die drei urspruenglichen
       Selektoren stammen von der Produktseite und kommen auf der Haar-LP
       NIRGENDS vor — Galerie-Klicks dort waren komplett ungemessen. Ausgerechnet
       diese Vorschaubilder erzeugten 6 der 8 Rage-Clicks der Seite, und der
       Fix dafuer (Vorladen der grossen Bilder) liess sich mangels Event nicht
       ueberpruefen. placement trennt die beiden Quellen. */
    var galerie = el.closest('.product__media, .product-media, .thumbnail-list, .kbb-gallery__thumb');
    if (galerie) {
      if (stateData.mediaInteracted) return;
      stateData.mediaInteracted = true;
      window.zfTrack('zf_media_interacted', {
        placement: galerie.classList.contains('kbb-gallery__thumb') ? 'lp_gallery' : 'pdp_gallery',
        seconds_since_load: secondsSinceLoad()
      });
    }
  }, true);

  /* ATC flips the exit summary — subscribe to the same pub/sub the cart uses,
     falling back to the dataLayer push zfTrack always makes. */
  (function watchAtc() {
    var origTrack = window.zfTrack;
    window.zfTrack = function (name, props, meta, options) {
      if (name === 'zf_add_to_cart') stateData.didAtc = true;
      return origTrack.call(this, name, props, meta, options);
    };
  })();

  /* ---------- exit summary ---------- */

  function sendExit(reason) {
    if (sent) return;
    sent = true;
    window.zfTrack('zf_pdp_exit', {
      page_type: pageType,
      exit_reason: reason,
      max_scroll_pct: stateData.maxScrollPct,
      dwell_seconds: secondsSinceLoad(),
      sections_seen_count: stateData.sectionsSeen.length,
      sections_seen: stateData.sectionsSeen.join(','),
      last_section: stateData.lastSection,
      buybox_seen: stateData.buyboxSeen,
      buybox_interacted: stateData.buyboxInteracted,
      faq_opened_count: stateData.faqOpened.length,
      media_interacted: stateData.mediaInteracted,
      did_add_to_cart: stateData.didAtc
    });
  }

  // pagehide is the reliable one on iOS/Safari; visibilitychange covers tab switches.
  window.addEventListener('pagehide', function () { sendExit('pagehide'); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') sendExit('hidden');
  });

  // prime maxScroll for visitors who never scroll
  onScroll();
})();
